import { useMemo } from "react";

import type { BlOption } from "Shared/Inputs/BlOption";
import { useClientsQuery } from "./useClientsQuery";

export function useClientOptions(): BlOption[] {
  const { data } = useClientsQuery({ offset: 0, limit: 1000 });

  return useMemo(
    () =>
      (data?.items ?? []).map((client) => ({
        value: client.clientID.toString(),
        label: client.companyName,
      })),
    [data],
  );
}
